import { useState, useCallback } from 'react';

export type ProdPrepStep = 'open-file' | 'status' | 'init' | 'sync' | 'done';

export interface UseModalStatesReturn {
  showExportLayoutModal: boolean;
  setShowExportLayoutModal: (show: boolean) => void;
  showLayoutOnlyPrompt: boolean;
  setShowLayoutOnlyPrompt: (show: boolean) => void;
  showRefuseModal: boolean;
  setShowRefuseModal: (show: boolean) => void;
  showCriticalModal: null | { message: string; onConfirm: () => void };
  setShowCriticalModal: (modal: null | { message: string; onConfirm: () => void }) => void;
  showProdPrep: boolean;
  setShowProdPrep: (show: boolean) => void;
  prodPrepStep: ProdPrepStep;
  setProdPrepStep: (step: ProdPrepStep) => void;
  snapshotApplying: boolean;
  setSnapshotApplying: (applying: boolean) => void;
  showChecklist: boolean;
  setShowChecklist: (show: boolean) => void;
  showInfoPanel: boolean;
  setShowInfoPanel: (show: boolean) => void;
  resetAllModals: () => void;
}

/**
 * Hook para gerenciar todos os estados de modais e overlays do OrderDetailsWindow
 */
export function useModalStates(): UseModalStatesReturn {
  const [showExportLayoutModal, setShowExportLayoutModal] = useState(false);
  const [showLayoutOnlyPrompt, setShowLayoutOnlyPrompt] = useState(false);
  const [showRefuseModal, setShowRefuseModal] = useState(false);
  const [showCriticalModal, setShowCriticalModal] = useState<null | { message: string; onConfirm: () => void }>(null);
  const [showProdPrep, setShowProdPrep] = useState(false);
  const [prodPrepStep, setProdPrepStep] = useState<ProdPrepStep>('open-file');
  const [snapshotApplying, setSnapshotApplying] = useState(false);
  const [showChecklist, setShowChecklist] = useState(false);
  const [showInfoPanel, setShowInfoPanel] = useState(false);

  const resetAllModals = useCallback(() => {
    setShowExportLayoutModal(false);
    setShowLayoutOnlyPrompt(false);
  }, []);

  return {
    showExportLayoutModal,
    setShowExportLayoutModal,
    showLayoutOnlyPrompt,
    setShowLayoutOnlyPrompt,
    showRefuseModal,
    setShowRefuseModal,
    showCriticalModal,
    setShowCriticalModal,
    showProdPrep,
    setShowProdPrep,
    prodPrepStep,
    setProdPrepStep,
    snapshotApplying,
    setSnapshotApplying,
    showChecklist,
    setShowChecklist,
    showInfoPanel,
    setShowInfoPanel,
    resetAllModals,
  };
}

